import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../resources/requestInfo";

import { ICard } from "./types";
import { cardsRoutes } from "./routes";
import { isTinkoffProvider } from "@/utils/payment/paymentProvider";

export const fetchGetCards = createAsyncThunk<ICard[]>(
  "getCards/fetchGetCards",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        isTinkoffProvider() ? cardsRoutes.TINKOFF_CARDS : cardsRoutes.GET_CARDS
      );
      return response.data;
    } catch (error: any) {
      console.log("error fetchGetCards >>>", error);
      return rejectWithValue(error.response?.data?.message || "Ошибка получения списка карт");
    }
  }
);

export const fetchGetCardById = createAsyncThunk<ICard, number>(
  "getCards/fetchGetCardById",
  async (cardId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(cardsRoutes.GET_CARD_BY_ID(cardId));
      return response.data;
    } catch (error: any) {
      console.log("error fetchGetCardById >>>", error);
      return rejectWithValue(error.response?.data?.message || "Ошибка получения карты");
    }
  }
);

export const fetchCreateCard = createAsyncThunk<ICard, { user_id: number; token: string; title: string }>(
  "getCards/fetchCreateCard",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(cardsRoutes.CREATE_CARD, data);
      return response.data;
    } catch (error: any) {
      console.log("error fetchCreateCard >>>", error);
      return rejectWithValue(error.response?.data?.message || "Ошибка создания карты");
    }
  }
);

export const fetchUpdateCard = createAsyncThunk<ICard, { id: number; token: string; title: string }>(
  "getCards/fetchUpdateCard",
  async (data, { rejectWithValue }) => {
    try {
      const { id, ...cardData } = data;
      const response = await axiosInstance.put(cardsRoutes.UPDATE_CARD(id), cardData);
      return response.data;
    } catch (error: any) {
      console.log("error fetchUpdateCard >>>", error);
      return rejectWithValue(error.response?.data?.message || "Ошибка обновления карты");
    }
  }
);

export const fetchDelCards = createAsyncThunk<void, number>(
    "delCards/fetchDelCards",
    async (cardId, { rejectWithValue }) => {
        try {
            await axiosInstance.delete(
                isTinkoffProvider()
                    ? cardsRoutes.TINKOFF_DELETE_CARD(cardId)
                    : cardsRoutes.DELETE_CARD(cardId)
            );
        } catch (error: any) {
            console.log("error fetchDelCards >>>", error);
            return rejectWithValue(error.response?.data?.message || "Ошибка удаления карты");
        }
    }
);

